import {NgModule} from "@angular/core";
import {LocationsSelectorComponent} from "./locations-selector.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@NgModule({
    declarations: [LocationsSelectorComponent],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [LocationsSelectorComponent]
})
export class LocationsSelectorModule {

}
